import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Image, ScrollArea, Stack, Text, rem } from '@mantine/core';
import { AsideRoomItem } from './AsideRoomItem';
import { available, joins } from './data';
export const AsideChallengesList: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Box pos="relative">
      <Image src="/assets/aside/deco.png" pos="absolute" top={0} style={{
      zIndex: 1
    }} alt="shadow" />
      <ScrollArea h={{
      base: 'calc(100vh - 250px)',
      sm: 'calc(100vh - 120px)'
    }} type="hover" scrollbars="y">
        <Stack pb={20} gap={0}>
          <Stack px={10} pt={26} gap={10}>
            <Text fz={{
            base: 14,
            sm: 18
          }} lh={rem(18)} className={gunterzBold.className}>
              {i18n._('Challenges')}
            </Text>
            {joins.map(item => <AsideRoomItem key={item.title} {...item} />)}
          </Stack>

          <Stack px={10} pt={40} gap={10}>
            <Text fz={{
            base: 14,
            sm: 18
          }} lh={rem(18)} className={gunterzBold.className}>
              {i18n._('AVAILABLE')}
            </Text>
            {available.map(item => <AsideRoomItem key={item.title} {...item} />)}
          </Stack>
        </Stack>
      </ScrollArea>
    </Box>;
};